<template>
  <div>
    Reviews list
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
